import React from 'react';
import { Rect, G } from 'react-native-svg';
import MultiplatformComponent from 'components/MultiplatformComponent';
import { Mat2d, Vec2, mat2d, vec2 } from 'utility/gl-matrix';

interface ProportionalRoundedCorners$Props {
  cornerRadius: number | null;
  appliedTransform: Mat2d;
  size: Vec2;
  children?: JSX.Element;
  color?: string | null;
}

const WebProportionalRoundedCorners = (props: ProportionalRoundedCorners$Props) => {
  let borderRadius = null;

  if (props.cornerRadius != null) {
    const scaleFactor = mat2d.scaleFactor(props.appliedTransform);
    const scaleAspectRatio = vec2.widthOverHeightAspectRatio(scaleFactor);
    if (scaleAspectRatio < 1) {
      borderRadius = [props.cornerRadius, props.cornerRadius * scaleAspectRatio];
    } else {
      borderRadius = [props.cornerRadius / scaleAspectRatio, props.cornerRadius];
    }
  }

  return (
    <G
        {...vec2.toSize(props.size)}
    >
      <Rect
        rx={borderRadius?.[0] ?? 0}
        ry={borderRadius?.[1] ?? 0}
        {...vec2.toSize(props.size)}
        {...(props.color == null ? {} : { fill: props.color })}
      />
      {props.children}
    </G>
  );
};

const ProportionalRoundedCorners = MultiplatformComponent({
  web: WebProportionalRoundedCorners,
});

export default ProportionalRoundedCorners;
